// extracted by mini-css-extract-plugin
export default {"component":"HowItWorks__component-igKJ","asterisk":"HowItWorks__asterisk-jTAy","steps":"HowItWorks__steps-bdW5"};